import { Component, OnInit, Inject, Renderer, ViewChild } from '@angular/core';
import {
  MAT_DIALOG_DATA, MatDialog
} from "@angular/material";
import { InformesService } from 'app/services/informes.service';
import { Subject } from 'rxjs';
import { Resultado } from 'app/clases/resultado';
import { Procedimiento } from 'app/clases/procedimiento';
import { HistoriaClinicaComponent } from '../historia-clinica/historia-clinica.component';
import swal from 'sweetalert2';
import { DataTableDirective } from 'angular-datatables';
declare var $;
@Component({
  selector: 'app-informacion-procedimientos',
  templateUrl: './informacion-procedimientos.component.html',
  styleUrls: ['./informacion-procedimientos.component.scss']
})
export class InformacionProcedimientosComponent implements OnInit {
  public dtConfig;
  public trigger:Subject<any>;
  public dtOptions:Array<Procedimiento>;
  public subject:Subject<any>;
  @ViewChild(DataTableDirective,{static:false}) tabla:DataTableDirective;
  constructor(@Inject(MAT_DIALOG_DATA) public data, private informesService:InformesService, private dialog:MatDialog, public renderer:Renderer) {
    this.trigger = new Subject();
    this.dtOptions = null;
    this.dtConfig = {
      columns:[
        {
          title:'Consecutivo',
          render: (data, type, row, meta) => {
            return `<a consecutivo="${data}" class="consecutivo">${data}</a>`
          }
        },
        {
          title:'Documento',
          data:'Documento'
        },
        {
          title:'Enfermero',
          data:'Enfermero'
        },
        {
          title:'Médico',
          data:'Medico'
        },
        {
          title:'Nombre',
          data:'Nombre'
        },
        {
          title:'telCelular',
          data:'telCelular'
        },
        {
          title:'telFijo',
          data:'telFijo'
        },
        {
          title:'telLlamada',
          data:'telLlamada'
        },
        {
          title:'Observaciones',
          data:'Observaciones'
        },
        {
          title:'Seguimiento',
          data:'Seguimiento'
        },
        // {
        //   title:'tratamiento_pro',
        //   data:'tratamiento_pro'
        // },
      ]
    };
  }
  ngOnInit() {
    console.log(this.data.fechaInicial)
    this.informesService.serviciosByTratamiento(this.data.tratamiento,this.data.fechaInicial,this.data.fechaFinal).subscribe((data:any)=>{
      this.dtOptions = data;
      this.trigger.next();
    })

  }

  observar(csc,flag,observacion){
    swal.fire({
      input:'textarea',
      inputPlaceholder:'Escribe la observacion',
      inputValue:observacion || "",

    }).then(success=>{
      if(!success.dismiss){
        this.informesService.setObservation(csc,flag,success.value).subscribe(async succ=>{
          await swal.fire({
            type:'success',
            title:'Exito!',
            text:'Se actualizó correctamente el comentario'
          })
          this.update()
        })
      }
    })
  }


  asignarRequerido(csc,flag,state){
    swal.fire({
      input:'select',
      inputOptions:{
        "1":"Requiere Seguimiento",
        "2":"No requiere Seguimiento"
      }
    }).then(succ=>{
      if(!succ.dismiss){
        this.informesService.setRequired(csc,flag,succ.value).subscribe(async success=>{
          await swal.fire({
            type:'success',
            title:'Exito',
            text:`Este servicios ahora ${(succ.value == "1")?"requiere":"no requiere"} seguimiento`
          })
          this.update();
        })
      }
    })
  }


  private async update(){
    let tabla:DataTables.Api;
    try{
      tabla = await this.tabla.dtInstance
    }catch(e){
      return;
    }
    this.informesService.serviciosByTratamiento(this.data.tratamiento,this.data.fechaInicial,this.data.fechaFinal).subscribe((data:any)=>{
      tabla.destroy();
      this.dtOptions = data;
      this.trigger.next();
    })
  }
}
